import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionTitleService {

  private title = new Subject<string>();

  constructor() { }

  get newTitle(){
    return this.title;
  }

  changeTitle(newTitle){
    this.title.next(newTitle);
  }
}
